import React, { useContext, useLayoutEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { GlobalContext } from "../../../../context/GlobalContext";
import dayjs from "dayjs";

function CoApplicantBirthday() {
  const { state, dispatch } = useContext(GlobalContext);

  // No default date — starts genuinely empty until the co-applicant's DOB
  // is actually picked, same as the primary applicant's Birthday.js.
  const [dob, setDob] = useState(
    state?.questions?.personal?.coApplicantDob
      ? dayjs(reformatDate(state?.questions?.personal?.coApplicantDob))
      : null
  );

  const inputRef = useRef();
  function extractDateFromDateObject(dateObject) {
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11, so add 1
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  function reformatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const year = dateObject.getFullYear();

    const formattedDate = `${month}-${day}-${year}`;

    return formattedDate;
  }

  // useLayoutEffect, not useEffect — see Birthday.js's own doc comment for
  // why: it closes the exact race window that made a pre-filled valid past
  // date fail validation on the first Continue click.
  useLayoutEffect(() => {
    if (!dob) return;
    const dateObject = new Date(dob);
    let obj = { ...state.questions?.personal };
    obj.coApplicantDob = extractDateFromDateObject(dateObject);
    dispatch({
      type: "QUESTION_PERSONAL",
      payload: obj,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dob]);

  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="pd6-dob-field">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          ref={inputRef}
          label={null}
          value={dob}
          onChange={(newValue) => setDob(newValue)}
          maxDate={dayjs()}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "outlined",
              placeholder: "MM/DD/YYYY",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
}

export default CoApplicantBirthday;
